export default __webpack_public_path__ + "static/media/star-score-outline.4d1ee850.svg";